// custom-snackbar.service.ts
import { inject,Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class CustomSnackbarService {
  private readonly snackBar = inject(MatSnackBar);


  openSuccess(message: string, action: string = 'Success', duration: number = 3000) {
    this.open(message, action, duration, 'success');

  }
  openError(message: string, action: string = 'Error', duration: number = 3000) {
    this.open(message, action, duration, 'error');
  }

  openInfo(message: string, action: string = 'Info', duration: number = 3000) {
    this.open(message, action, duration, 'info');
  }

  private open(message: string, action: string, duration: number, type: 'error' | 'success' | 'info' = 'error') {

    this.snackBar.open(message, action, {
      duration: duration,
      panelClass: ['custom-snackbar', `custom-snackbar-${type}`]
    });
  }
}
